<template>
  <section class="app-main" @click="hidePanel">
    <div class="mbTip">
      温馨提示：站内信模板消息为自动触发，中英文触发内容、中英文标题为必填项！
    </div>
    <div style="margin: 0 20px 20px 0; text-align: right">
      <el-button type="primary" @click="detail_modal = true">添加</el-button>
    </div>
    <el-dialog
      title="站内信模板消息添加"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1000px"
    >
      <div class="textarea">
        <div class="msgEdit">
          <el-input
            type="text"
            placeholder="请输入中文标题"
            v-model="zh_name"
            autocomplete="off"
            style="width: 100%"
          >
          </el-input>
          <el-input
            type="text"
            placeholder="请输入中文链接"
            v-model="zh_link"
            autocomplete="off"
            style="width: 100%; margin-top: 10px"
          >
          </el-input>
          <div class="emjioBox" id="emjioBox" v-if="viewEmjio">
            <div class="emjioMain">
              <span
                v-for="(item, index) in emjioStr.split(',')"
                :key="index"
                @click="submitEmjio(item, 1)"
                @mouseenter="emjioActive = item"
              >
                {{ item }}
              </span>
            </div>
            <div class="emjioList">
              <span
                v-for="(item, index) in emjio"
                :key="index"
                @mouseenter="emjioStr = item"
                >{{ index }}</span
              >
            </div>
            <div class="viewEmjio">{{ emjioActive }}</div>
          </div>
          <div class="msgTools">
              <span>
            <img :class="viewEmjio ? 'activeEmjio' : ''"
            @click.stop="viewEmjio = !viewEmjio" :src="viewEmjio? require('@/assets/icon/expression2.png'): require('@/assets/icon/expression.png')"  alt="">
          </span>
            <span>
            <img @click="zh_textarea += '[money]'" src="@/assets/icon/money.png" alt="">
          </span>
          <span>
            <img @click="zh_textarea += '[name]'"  src="@/assets/icon/person.png" alt="">
          </span>
          <span>
            <img @click="zh_textarea += '[day]'"  src="@/assets/icon/day.png" alt="">
          </span>
          <span>
            <img @click="zh_textarea += '[month]'"  src="@/assets/icon/month.png" alt="">
          </span>
          </div>
          <el-input
            id="msgContent"
            type="textarea"
            placeholder="请输入中文推送内容，示例：内容#*****#包裹跳转超链接"
            v-model="zh_textarea"
            @focus="viewEmjio = false"
            :rows="5"
            show-word-limit
            autocomplete="off"
          >
          </el-input>
        </div>
        <div class="msgEdit">
          <el-input
            type="text"
            placeholder="请输入英文标题"
            v-model="en_name"
            autocomplete="off"
            style="width: 100%"
          >
          </el-input>
          <el-input
            type="text"
            placeholder="请输入英文链接"
            v-model="en_link"
            autocomplete="off"
            style="width: 100%; margin-top: 10px"
          >
          </el-input>
          <div class="emjioBox" id="emjioBox2" v-if="viewEmjio2">
            <div class="emjioMain">
              <span
                v-for="(item, index) in emjioStr.split(',')"
                :key="index"
                @click="submitEmjio(item, 2)"
                @mouseenter="emjioActive = item"
              >
                {{ item }}
              </span>
            </div>
            <div class="emjioList">
              <span
                v-for="(item, index) in emjio"
                :key="index"
                @mouseenter="emjioStr = item"
                >{{ index }}</span
              >
            </div>

            <div class="viewEmjio">{{ emjioActive }}</div>
          </div>
          <div class="msgTools">
             <span>
            <img :class="viewEmjio2 ? 'activeEmjio' : ''"
            @click.stop="viewEmjio2 = !viewEmjio2" :src="viewEmjio2 ?  require('@/assets/icon/expression2.png'): require('@/assets/icon/expression.png')"  alt="">
          </span>
            <span>
            <img @click="en_textarea += '[money]'" src="@/assets/icon/money.png" alt="">
          </span>
          <span>
            <img @click="en_textarea += '[name]'"  src="@/assets/icon/person.png" alt="">
          </span>
          <span>
            <img @click="en_textarea += '[day]'"  src="@/assets/icon/day.png" alt="">
          </span>
          <span>
            <img @click="en_textarea += '[month]'"  src="@/assets/icon/month.png" alt="">
          </span>
          </div>
          <el-input
            id="msgContent2"
            type="textarea"
            placeholder="请输入英文推送内容，示例：内容#*****#包裹跳转超链接"
            v-model="en_textarea"
            @focus="viewEmjio2 = false"
            :rows="5"
            show-word-limit
            autocomplete="off"
          >
          </el-input>
        </div>
      </div>
      <div class="submit">
        <el-button type="primary" round @click="submit">提交</el-button>
      </div>
    </el-dialog>
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @selection-change="tableChange"
        height="500"
        style="width: 100%"
      >
        <el-table-column prop="created_at" label="添加时间" align="center">
        </el-table-column>
        <el-table-column
          prop="zh_name"
          label="中文标题"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="en_name"
          label="英文标题"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="link_zh"
          label="中文链接"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link
            type="primary"
              v-if="scope.row.link_zh != '' && scope.row.link_zh != null"
              >{{ scope.row.link_zh }}</el-link
            >
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="link_en"
          label="英文链接"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link
            type="primary"
              v-if="scope.row.link_en != '' && scope.row.link_en != null"
              >{{ scope.row.link_en }}</el-link
            >
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="content_zh" label="中文推送内容" align="center">
          <template slot-scope="scope">
            <span class="sendContent">{{ scope.row.content_zh }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="content_en" label="英文推送内容" align="center">
          <template slot-scope="scope">
            <span class="sendContent">{{ scope.row.content_en }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_amount" label="详情" align="center">
          <template slot-scope="scope">
            <el-button
              @click="showDetail(scope.row)"
              type="primary"
              plain
              size="mini"
              >编辑</el-button
            >
            <el-button
              @click="delDetail(scope.row.id)"
              type="danger"
              plain
              size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>
    <!-- 展开商品详情弹框 -->
    <el-dialog
      title="站内信模板消息编辑"
      :visible.sync="detail_modal2"
      :close-on-click-modal="false"
      center
      width="1000px"
    >
      <div class="textarea editText">
        <div class="msgEdit">
          <el-input
            type="text"
            placeholder="请输入中文标题"
            v-model="detail.zh_name"
            autocomplete="off"
            style="width: 100%"
          >
          </el-input>
          <el-input
            type="text"
            placeholder="请输入中文链接"
            v-model="detail.link_zh"
            autocomplete="off"
            style="width: 100%; margin-top: 10px"
          >
          </el-input>
          <div class="emjioBox" v-if="viewEmjio">
            <div class="emjioMain">
              <span
                v-for="(item, index) in emjioStr.split(',')"
                :key="index"
                @click="submitEmjio(item, 1)"
                @mouseenter="emjioActive = item"
              >
                {{ item }}
              </span>
            </div>
            <div class="emjioList">
              <span
                v-for="(item, index) in emjio"
                :key="index"
                @mouseenter="emjioStr = item"
                >{{ index }}</span
              >
            </div>

            <div class="viewEmjio">{{ emjioActive }}</div>
          </div>
          <div class="msgTools">
           <span>
            <img :class="viewEmjio ? 'activeEmjio' : ''"
            @click.stop="viewEmjio = !viewEmjio" :src="viewEmjio? require('@/assets/icon/expression2.png'): require('@/assets/icon/expression.png')" alt="">
          </span>
            <span>
            <img @click="detail.content_zh += '[money]'" src="@/assets/icon/money.png" alt="">
          </span>
          <span>
            <img @click="detail.content_zh += '[name]'"  src="@/assets/icon/person.png" alt="">
          </span>
          <span>
            <img @click="detail.content_zh += '[day]'"  src="@/assets/icon/day.png" alt="">
          </span>
          <span>
            <img @click="detail.content_zh += '[month]'"  src="@/assets/icon/month.png" alt="">
          </span>
          </div>
          <el-input
            id="msgContent"
            type="textarea"
            placeholder="请输入中文推送内容，示例：内容#*****#包裹跳转超链接"
            v-model="detail.content_zh"
            @focus="viewEmjio = false"
            :rows="5"
            show-word-limit
            autocomplete="off"
          >
          </el-input>
        </div>
        <div class="msgEdit">
          <el-input
            type="text"
            placeholder="请输入英文标题"
            v-model="detail.en_name"
            autocomplete="off"
            style="width: 100%"
          >
          </el-input>
          <el-input
            type="text"
            placeholder="请输入英文链接"
            v-model="detail.link_en"
            autocomplete="off"
            style="width: 100%; margin-top: 10px"
          >
          </el-input>
          <div class="emjioBox" v-if="viewEmjio2">
            <div class="emjioMain">
              <span
                v-for="(item, index) in emjioStr.split(',')"
                :key="index"
                @click="submitEmjio(item, 2)"
                @mouseenter="emjioActive = item"
              >
                {{ item }}
              </span>
            </div>
            <div class="emjioList">
              <span
                v-for="(item, index) in emjio"
                :key="index"
                @mouseenter="emjioStr = item"
                >{{ index }}</span
              >
            </div>

            <div class="viewEmjio">{{ emjioActive }}</div>
          </div>
          <div class="msgTools">
           <span>
            <img :class="viewEmjio2 ? 'activeEmjio' : ''"
            @click.stop="viewEmjio2 = !viewEmjio2" :src="viewEmjio2?  require('@/assets/icon/expression2.png'): require('@/assets/icon/expression.png')"  alt="">
          </span>
            <span>
            <img @click="detail.content_en += '[money]'" src="@/assets/icon/money.png" alt="">
          </span>
          <span>
            <img @click="detail.content_en += '[name]'"  src="@/assets/icon/person.png" alt="">
          </span>
          <span>
            <img @click="detail.content_en += '[day]'"  src="@/assets/icon/day.png" alt="">
          </span>
          <span>
            <img @click="detail.content_en += '[month]'"  src="@/assets/icon/month.png" alt="">
          </span>
          </div>
          <el-input
            id="msgContent2"
            type="textarea"
            placeholder="请输入英文推送内容，示例：内容#*****#包裹跳转超链接"
            v-model="detail.content_en"
            @focus="viewEmjio2 = false"
            :rows="5"
            show-word-limit
            autocomplete="off"
          >
          </el-input>
        </div>
      </div>
      <el-card style="margin-top: 20px">
        <el-row class="m-bottom-4" style="width: 30%">
          <el-col :span="8" class="input-left"> 提交修改： </el-col>
          <el-col :span="16">
            <el-button
              @click="handleSubmit(detail)"
              type="success"
              plain
              style="width: 150px"
              >确认修改</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
  </section>
</template>

<script>
import { push_list, addMb, delMb, saveMb } from "@/api/market.js";
export default {
  data() {
    return {
      zh_textarea: "",
      en_textarea: "",
      viewEmjio: false, // 显示表情
      viewEmjio2: false,
      en_name: "",
      zh_name: "",
      zh_link: "",
      en_link: "",
      emjio: {
        表情:
          "😀,😁,😂,😃,😄,😅,😆,😉,😊,😋,😎,😍,😘,😗,😙,😚,😇,😐,😑,😶,😏,😣,😥,😮,😯,😪,😫,😴,😌,😛,😜,😝,😒,😓,😔,😕,😲,😷,😖,😞,😟,😤,😢,😭,😦,😧,😨,😬,😰,😱,😳,😵,😡,😠",
        人物:
          "👦,👧,👨,👩,👴,👵,👶,👱,👮,👲,👳,👷,👸,💂,🎅,👰,👼,💆,💇,🙍,🙎,🙅,🙆,💁,🙋,🙇,🙌,🙏,👤,👥,🚶,🏃,👯,💃,👫,👬,👭,💏,💑,👪",
        手势: "💪,👈,👉,☝,👆,👇,✌,✋,👌,👍,👎,✊,👊,👋,👏,👐,✍",
        日常:
          "📱,📲,📶,📳,📴,☎,📞,📟,📠,👣,👀,👂,👃,👅,👄,💋,👓,👔,👕,👖,👗,👘,👙,👚,👛,👜,👝,🎒,💼,👞,👟,👠,👡,👢,👑,👒,🎩,🎓,💄,💅,💍,🌂",
        公共:
          "💘,❤,💓,💔,💕,💖,💗,💙,💚,💛,💜,💝,💞,💟,❣,♻,🏧,🚮,🚰,♿,🚹,🚺,🚻,🚼,🚾,⚠,🚸,⛔,🚫,🚳,🚭,🚯,🚱,🚷,🔞,💈",
        动物:
          "🙈,🙉,🙊,🐵,🐒,🐶,🐕,🐩,🐺,🐱,😺,😸,😹,😻,😼,😽,🙀,😿,😾,🐈,🐯,🐅,🐆,🐴,🐎,🐮,🐂,🐃,🐄,🐷,🐖,🐗,🐽,🐏,🐑,🐐,🐪,🐫,🐘,🐭,🐁,🐀,🐹,🐰,🐇,🐻,🐨,🐼,🐾,🐔,🐓,🐣,🐤,🐥,🐦,🐧,🐸,🐊,🐢,🐍,🐲,🐉,🐳,🐋,🐬,🐟,🐠,🐡,🐙,🐚,🐌,🐛,🐜,🐝,🐞,🦋",
        自然:
          "💐,🌸,💮,🌹,🌺,🌻,🌼,🌷,🌱,🌲,🌳,🌴,🌵,🌾,🌿,🍀,🍁,🍂,🍃,🌍,🌎,🌏,🌐,🌑,🌒,🌓,🌔,🌕,🌖,🌗,🌘,🌙,🌚,🌛,🌜,☀,🌝,🌞,⭐,🌟,🌠,☁,⛅,☔,⚡,❄,🔥,💧,🌊",
        饮食:
          "🍇,🍈,🍉,🍊,🍋,🍌,🍍,🍎,🍏,🍐,🍑,🍒,🍓,🍅,🍆,🌽,🍄,🌰,🍞,🍖,🍗,🍔,🍟,🍕,🍳,🍲,🍱,🍘,🍙,🍚,🍛,🍜,🍝,🍠,🍢,🍣,🍤,🍥,🍡,🍦,🍧,🍨,🍩,🍪,🎂,🍰,🍫,🍬,🍭,🍮,🍯,🍼,☕,🍵,🍶,🍷,🍸,🍹,🍺,🍻,🍴",
        文体:
          "🎪,🎭,🎨,🎰,🚣,🛀,🎫,🏆,⚽,⚾,🏀,🏈,🏉,🎾,🎱,🎳,⛳,🎣,🎽,🎿,🏂,🏄,🏇,🏊,🚴,🚵,🎯,🎮,🎲,🎷,🎸,🎺,🎻,🎬",
        旅游:
          "🌋,🗻,🏠,🏡,🏢,🏣,🏤,🏥,🏦,🏨,🏩,🏪,🏫,🏬,🏭,🏯,🏰,💒,🗼,🗽,⛪,⛲,🌁,🌃,🌆,🌇,🌉,🌌,🎠,🎡,🎢,🚂,🚃,🚄,🚅,🚆,🚇,🚈,🚉,🚊,🚝,🚞,🚋,🚌,🚍,🚎,🚏,🚐,🚑,🚒,🚓,🚔,🚕,🚖,🚗,🚘,🚚,🚛,🚜,🚲,⛽,🚨,🚥,🚦,🚧,⚓,⛵,🚤,🚢,✈,💺,🚁,🚟,🚠,🚡,🚀,🎑,🗿,🛂,🛃,🛄,🛅",
        物品:
          "💌,💎,🔪,💈,🚪,🚽,🚿,🛁,⌛,⏳,⌚,⏰,🎈,🎉,🎊,🎎,🎏,🎐,🎀,🎁,📯,📻,📱,📲,☎,📞,📟,📠,🔋,🔌,💻,💽,💾,💿,📀,🎥,📺,📷,📹,📼,🔍,🔎,🔬,🔭,📡,💡,🔦,🏮,📔,📕,📖,📗,📘,📙,📚,📓,📃,📜,📄,📰,📑,🔖,💰,💴,💵,💶,💷,💸,💳,✉,📧,📨,📩,📤,📥,📦,📫,📪,📬,📭,📮,✏,✒,📝,📁,📂,📅,📆,📇,📈,📉,📊,📋,📌,📍,📎,📏,📐,✂,🔒,🔓,🔏,🔐,🔑,🔨,🔫,🔧,🔩,🔗,💉,💊,🚬,🔮,🚩,🎌,💦,💨",
        标志:
          "♠,♥,♦,♣,🀄,🎴,🔇,🔈,🔉,🔊,📢,📣,💤,💢,💬,💭,♨,🌀,🔔,🔕,✡,✝,🔯,📛,🔰,🔱,⭕,✅,☑,✔,✖,❌,❎,➕,➖,➗,➰,➿,〽,✳,✴,❇,‼,⁉,❓,❔,❕,❗,©,®,™,🎦,🔅,🔆,💯,🔠,🔡,🔢,🔣,🔤,🅰,🆎,🅱,🆑,🆒,🆓,ℹ,🆔,Ⓜ,🆕,🆖,🅾,🆗,🅿,🆘,🆙,🆚,🈁,🈂,🈷,🈶,🈯,🉐,🈹,🈚,🈲,🉑,🈸,🈴,🈳,㊗,㊙,🈺,🈵,▪,▫,◻,◼,◽,◾,⬛,⬜,🔶,🔷,🔸,🔹,🔺,🔻,💠,🔲,🔳,⚪,⚫,🔴,🔵",
        钟表:
          "🕛,🕧,🕐,🕜,🕑,🕝,🕒,🕞,🕓,🕟,🕔,🕠,🕕,🕡,🕖,🕢,🕗,🕣,🕘,🕤,🕙,🕥,🕚,🕦,⌛,⏳,⌚,⏰,⏱,⏲,🕰",
        交通:
          "🚂,🚃,🚄,🚅,🚆,🚇,🚈,🚉,🚊,🚝,🚞,🚋,🚌,🚍,🚎,🚏,🚐,🚑,🚒,🚓,🚔,🚕,🚖,🚗,🚘,🚚,🚛,🚜,🚲,⛽,🚨,🚥,🚦,🚧,⚓,⛵,🚣,🚤,🚢,✈,💺,🚁,🚟,🚠,🚡,🚀",
        办公:
          "📱,📲,☎,📞,📟,📠,🔋,🔌,💻,💽,💾,💿,📀,🎥,📺,📷,📹,📼,🔍,🔎,🔬,🔭,📡,📔,📕,📖,📗,📘,📙,📚,📓,📃,📜,📄,📰,📑,🔖,💳,✉,📧,📨,📩,📤,📥,📦,📫,📪,📬,📭,📮,✏,✒,📝,📁,📂,📅,📆,📇,📈,📉,📊,📋,📌,📍,📎,📏,📐,✂,🔒,🔓,🔏,🔐,🔑",
        箭头: "⬆↗➡↘⬇↙⬅↖↕↔↩↪⤴⤵🔃🔄🔙🔚🔛🔜🔝",
      },
      emjioStr:
        "😀,😁,😂,😃,😄,😅,😆,😉,😊,😋,😎,😍,😘,😗,😙,😚,😇,😐,😑,😶,😏,😣,😥,😮,😯,😪,😫,😴,😌,😛,😜,😝,😒,😓,😔,😕,😲,😷,😖,😞,😟,😤,😢,😭,😦,😧,😨,😬,😰,😱,😳,😵,😡,😠", // 表情字符列表
      emjioActive: "😆",
      total: 0,
      page: 1,
      size: 10,
      tableData: [],
      detail: {},
      detail_modal: false,
      detail_modal2: false,
    };
  },
  methods: {
    getData() {
      let params = {
        flag: 1,
      };
      push_list(params)
        .then((res) => {
          if (res.code == 20000) {
            this.tableData = res.data.data;
            this.size = res.data.per_page;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    reloadData(page) {
      this.page = page;
      this.getData();
    },
    showDetail(row) {
      console.log(row);
      this.detail = row;
      this.detail_modal2 = true;
    },
    handleSubmit(detail) {
      if (detail.content_zh != "" && detail.content_en != "") {
        this.$confirm("此操作将修改此站内信模板消息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            content_zh: detail.content_zh,
            content_en: detail.content_en,
            link_zh: detail.link_zh,
            link_en: detail.link_en,
            en_name: detail.en_name,
            zh_name: detail.zh_name,
          };
          saveMb(detail.id, params).then((res) => {
            if (res.code == 20000) {
              this.detail_modal2 = false;
              this.page = 1;
              this.getData();
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        });
      } else {
        this.$message.error("请确认中英文内容！");
      }
    },
    delDetail(id) {
      console.log(id);
      this.$confirm("此操作将删除站内信模板消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delMb(id).then((res) => {
            if (res.code == 20000) {
              this.page = 1;
              this.getData();
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitEmjio(e, index) {
      if (index == 1) {
        var obj = document.getElementById("msgContent");
        if (document.selection) {
          obj.focus();
          var sel = document.selection.createRange();
          sel.text = e;
        } else if (
          typeof obj.selectionStart === "number" &&
          typeof obj.selectionEnd === "number"
        ) {
          var startPos = obj.selectionStart;
          var endPos = obj.selectionEnd;
          var tmpStr = obj.value;
          this.zh_textarea =
            tmpStr.substring(0, startPos) +
            e +
            tmpStr.substring(endPos, tmpStr.length);
        } else {
          this.zh_textarea += e;
        }
      } else {
        var obj2 = document.getElementById("msgContent2");
        if (document.selection) {
          obj2.focus();
          var sel2 = document.selection.createRange();
          sel2.text = e;
        } else if (
          typeof obj2.selectionStart === "number" &&
          typeof obj2.selectionEnd === "number"
        ) {
          var startPos2 = obj2.selectionStart;
          var endPos2 = obj2.selectionEnd;
          var tmpStr2 = obj2.value;
          this.en_textarea =
            tmpStr2.substring(0, startPos2) +
            e +
            tmpStr2.substring(endPos2, tmpStr2.length);
        } else {
          this.en_textarea += e;
        }
      }
    },
    submit() {
      if (this.zh_textarea != "" && this.en_textarea != "" && this.en_name != ""&& this.zh_name != "") {
        this.$confirm("此操作将添加此站内信模板消息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              en_name: this.en_name,
              zh_name: this.zh_name,
              content_zh: this.zh_textarea,
              content_en: this.en_textarea,
            };
            if (this.zh_link != "") {
              params.link_zh = this.zh_link;
            }
            if (this.en_link != "") {
              params.link_en = this.en_link;
            }
            addMb(params).then((res) => {
              if (res.code == 20000) {
                this.$message.success("提交成功");
                this.page = 1;
                this.zh_textarea = "";
                this.en_textarea = "";
                this.zh_link = "";
                this.en_link = "";
                this.zh_name = "";
                this.en_name = "";
                this.detail_modal = false;
                this.getData();
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.error("请确认中英文内容！");
      }
    },
    hidePanel(event) {
      var sp = document.getElementById("emjioBox");
      var sp2 = document.getElementById("emjioBox2");
      if (sp) {
        if (!sp.contains(event.target)) {
          //这句是说如果我们点击到了id为myPanel以外的区域

          this.viewEmjio = false;
        }
      }
      if (sp2) {
        if (!sp2.contains(event.target)) {
          //这句是说如果我们点击到了id为myPanel以外的区域

          this.viewEmjio2 = false;
        }
      }
    },
  },
  created() {
    // this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
section {
  height: calc(100% - 60px);
  .title {
    font-size: 18px;
    color: #141414;
    line-height: 60px;
    letter-spacing: 0.4px;
    text-align: left;
  }
  .mbTip {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
    background-color: #ffebdb;
    border: 2px solid #ffbe89;
    font-size: 14px;
    line-height: 23px;
    margin: 14px 0 15px 0;
    color: #666;
  }
  .showTextarea {
    width: 100% !important;
    .msgEdit:nth-child(1) {
      width: 40%;
    }
    .msgEdit:nth-child(2) {
      width: 40%;
      margin-right: 10%;
    }
  }
  .editText {
    box-shadow: 0 2px 12px 0 rgb(219, 219, 219);
    border-radius: 2px;
    padding: 20px;
    box-sizing: border-box;
  }
  .textarea {
    width: 100%;
    min-height: 290px;
    display: flex;
    justify-content: space-between;
    .msgEdit {
      // width: 100%;
      height: 200px;
      position: relative;
      .emjioBox {
        position: absolute;
        top: -90px;
        width: 688px;
        height: 180px;
        border: 1px solid #e1e1e1;
        background-color: #fff;
        z-index: 999;
        .emjioMain {
          width: calc(100% - 160px);
          height: 140px;
          padding: 20px;
          box-sizing: border-box;
          overflow-y: auto;
          position: relative;
          span {
            width: 35px;
            height: 35px;
            display: inline-block;
            font-size: 23px;
            cursor: pointer;
            border: 1px solid transparent;
            line-height: 35px;
            text-align: center;
            margin: 0 2px 2px 0;
            transition: all 0.5s;
            &:hover {
              border-color: darkcyan;
            }
          }
        }
        .viewEmjio {
          position: absolute;
          right: 0;
          top: 0px;
          width: 160px;
          height: 140px;
          border-left: 1px solid #e1e1e1;
          line-height: 140px;
          text-align: center;
          font-size: 80px;
        }
        .emjioList {
          width: 100%;
          height: 40px;
          background-color: #f1f1f1;
          span {
            display: inline-block;
            width: 43px;
            height: 100%;
            text-align: center;
            line-height: 40px;
            font-size: 12px;
            color: #555;
            transition: all 0.5s;
            &:hover {
              background-color: #e1e1e1;
              cursor: pointer;
            }
          }
        }
      }
      .msgTools {
        width: 100%;
        height: 35px;
        span {
          display: inline-block;
          margin-top: 8px;
          margin-right: 5px;
          font-size: 20px;
          width: 25px;
          height: 25px;
          transition: all 0.5s;
          text-align: center;
          border-radius: 20%;
          img {
            width: 90%;
            height: 90%;
          }
        }
      }
      #msgContent,
      #msgContent2 {
        width: calc(100% - 20px);
        height: 100px;
        border: 1px solid #f1f1f1;
        padding: 10px;
        font-size: 14px;
        color: #666;
        resize: none;
      }
    }
    div {
      width: 45%;
      p {
        line-height: 42px;
        letter-spacing: 0.3px;
        font-size: 16px;
        color: #141414;
        margin-right: 20px;
      }
      /deep/ .el-textarea {
        width: 100%;
        /deep/ .el-textarea__inner {
          // 然后找到对应的类名，在这里将拉伸去掉即可
          resize: none;
        }
      }
    }
  }
  .submit {
    width: 100%;
    margin: 10px 0 20px;
    text-align: right;
    /deep/ .el-button {
      width: 100px;
    }
  }
  .sendContent {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row-height {
    height: 40px;
    line-height: 40px;
    .row-span + .row-span {
      margin-left: 15px;
    }
    .row-total {
      margin-left: 30px;
      font-size: 16px;
      font-weight: bold;
      padding: 0 30px 10px 0;
    }
  }
}
</style>